// @flow

import axios from 'axios';
import queryString from 'query-string';
import type { ProvisioningType, CreateSubcriptionAndProvisionRequest } from '../../types';
import { getMsStartupQueryParams } from '../../helpers';

const getProvisioningType = (
  enabledMsStartupSignup: boolean,
  enabledStartupConferenceSignup: boolean,
): ProvisioningType => {
  if (enabledMsStartupSignup) return 'MsStartUp';
  if (enabledStartupConferenceSignup) return 'StartupConference';
  return 'FreeTrial';
};

export const saveSubscription = async ({
  customerId,
  email,
  executeRecaptcha,
  setRecaptchaFailed,
  enabledMsStartupSignup,
  enabledStartupConferenceSignup,
}: any) => {
  const recaptchaAction = 'OnBoardingSaveSubscription';
  const recaptchaToken = await executeRecaptcha(recaptchaAction);
  const params = queryString.parse(window.location.search);
  const provisioningType: ProvisioningType = getProvisioningType(
    enabledMsStartupSignup,
    enabledStartupConferenceSignup,
  );
  const noAnswer = enabledMsStartupSignup || enabledStartupConferenceSignup ? '' : 'No answer';
  let dto = {
    CustomerType: noAnswer,
    CustomerId: customerId,
    RecaptchaToken: recaptchaToken,
    RecaptchaAction: recaptchaAction,
    UtmSource: params.utm_source,
    UtmMedium: params.utm_medium,
    UtmCampaign: params.utm_campaign,
    ProvisioningType: provisioningType,
  };
  if (!enabledMsStartupSignup && !enabledStartupConferenceSignup) {
    dto = {
      ...dto,
      OutcomeType: noAnswer,
      OutcomeSubtype: noAnswer,
      OutcomeStage: 'Ready for Due Diligence',
      ExtraRequest: 'From Mobile',
    };
  }
  const response = await axios.post(`${window.location.origin}/free-trial/save-subscription`, {
    dto,
  });

  if (response.data.Status === 0) {
    const encodedEmail = encodeURIComponent(btoa(email));
    window.location.href = `/free-trial-thankyou?e=${encodedEmail}${getMsStartupQueryParams(
      enabledMsStartupSignup,
      enabledStartupConferenceSignup,
    )}`;
  } else if (response.data.Status === 3) {
    setRecaptchaFailed(true);
  } else {
    window.location.href = '/500';
  }
};

export const getSocialSignupLink = (
  provider: 'google' | 'linkedin' | 'microsoft',
  redirectPath: string,
): string => {
  const { hostname, protocol } = window.location;
  let subdomain;
  if (
    hostname.includes('localhost') ||
    hostname.includes('dev1') ||
    !hostname.includes('ansarada.com') // localhost but using ip addresses
  ) {
    subdomain = 'dev1';
  } else if (hostname.includes('staging')) {
    subdomain = 'staging';
  } else {
    subdomain = '';
  }
  const substr = subdomain ? `${subdomain}.` : '';

  return `${protocol}//id.${substr}ansarada.com/signup/free-trial/social?provider=${provider}&redirectPath=${redirectPath}`;
};

export const createSubsriptionAndProvision = async (
  request: CreateSubcriptionAndProvisionRequest,
): any => {
  const params = queryString.parse(window.location.search);
  const response = await axios.post(`${window.location.origin}/free-trial/provision-subscription`, {
    dto: {
      Email: request.email,
      ProvisioningType: 'MsStartUp',
      WorkflowTemplate: null,
      SignupUserId: request.signupUserId,
      RecaptchaAction: request.recaptchaAction,
      RecaptchaToken: request.recaptchaToken,
      UtmSource: params.utm_source,
      UtmMedium: params.utm_medium,
      UtmCampaign: params.utm_campaign,
      UtmContent: params.utm_content,
      PartnerName: null,
      PartnerShip: null,
      CustomerType: null,
      ExtraRequest: null,
      Industry: null,
      IndustryId: null,
      OutcomeStage: null,
      OutcomeSubtype: null,
      OutcomeType: null,
      SubIndustry: null,
      SubIndustryId: null,
      TransactionType: null,
      TransactionTypeId: null,
      TransactionTypeOther: null,
    },
  });
  return response;
};
